import { DataFilter } from '@siclop/kstone-vue'
import { ContractType } from '../enums/ContractType'

/**
 * Filter for employees
 */
export class EmployeeFilter extends DataFilter {
  personId?: number
  organizationId?: number
  professionId?: number
  contractType?: ContractType
  isActive?: boolean

  constructor(search?: string) {
    super()
    this.search = search
  }

  override toQueryString(): string {
    const url = super.toQueryString()
    const separator = url.includes('?') ? '&' : '?'
    const params: string[] = []

    if (this.personId !== undefined) {
      params.push(`PersonId=${this.personId}`)
    }
    if (this.organizationId !== undefined) {
      params.push(`OrganizationId=${this.organizationId}`)
    }
    if (this.professionId !== undefined) {
      params.push(`ProfessionId=${this.professionId}`)
    }
    if (this.contractType !== undefined) {
      params.push(`ContractType=${this.contractType}`)
    }
    if (this.isActive !== undefined) {
      params.push(`ActiveOnly=${this.isActive}`)
    }

    return params.length > 0 ? `${url}${separator}${params.join('&')}` : url
  }
}
